import type { Component } from 'vue'

export interface PickerContext {
    identityId?: number
    providerOptionId?: number
}

export interface PickerDefinition {
    name: string
    editComponent: Component
    resolveLabel: (value: string, context: PickerContext) => Promise<string | null>
}

// Module-level singleton — shared across all composable calls
const _registry = new Map<string, PickerDefinition>()

export function usePickerRegistry() {
    function register(picker: PickerDefinition) {
        _registry.set(picker.name, picker)
    }

    function get(name: string): PickerDefinition | undefined {
        return _registry.get(name)
    }

    function has(name: string): boolean {
        return _registry.has(name)
    }

    return { register, get, has }
}
